import {Component} from '@angular/core';
import {kanUsersService} from "../../../services/services/users";
import {MatDialogRef} from "@angular/material";

@Component({
    selector: 'kan-new-user-bundle-dialog',
    templateUrl: './component.html',
    styleUrls: ['./component.scss']
})
export class kanUserBundleDialog {
    public newUser: object = {
        name: '',
        surname: '',
        email: '',
        phone: ''
    }

    constructor(private dialogRef: MatDialogRef<kanUserBundleDialog>, private userService: kanUsersService) {
    }

    ngOnInit(): void {
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/dialogs/user-bundle-dialog/component.ts